import React, { FC, useEffect } from 'react'
import { Field, FieldArray, useFormikContext } from 'formik'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Checkbox } from '@ucheba/ui/components/Checkbox/desktop'
import { useExams, useFieldAddEge } from '../bll'
import { IFieldsAddEge } from '../types'
import { extraExams } from '../constants'
import SelectEgeDialogEgeItem from './SelectEgeDialogEgeItem'

const extra = (
  <Text html={false}>
    Сдам дополнительный экзамен
    <Spacing spacing='usmall' />
    <Text fontSize='small1' color='gray60'>
      На некоторые специальности дополнительно нужно сдавать творческие или
      профессиональные экзамены
    </Text>
  </Text>
)

const SelectEgeDialogEge: FC<IFieldsAddEge> = (props) => {
  const { values, initialValues } = props
  const exams = useExams(values)

  const ctx = useFormikContext()

  // костыль чтобы перерендить про обновление initialValues
  useEffect(() => {
    ctx.setValues(initialValues)
  }, [initialValues])

  const { getExams } = useFieldAddEge(exams, values)

  return (
    <Grid spacing='xlarge'>
      <FieldArray
        name='egeList'
        render={(arrayHelper) => (
          <>
            {values.map((item, index) => {
              return (
                <GridCol key={index} uxs={24}>
                  <SelectEgeDialogEgeItem
                    list={getExams(index)}
                    item={item}
                    examIdName={`egeList.${index}.examId`}
                    scoreName={`egeList.${index}.score`}
                    onDelete={() => {
                      arrayHelper.remove(index)
                    }}
                  />
                </GridCol>
              )
            })}

            <GridCol uxs={24}>
              <Button
                block
                view='outline'
                color='blue'
                disabled={values.length === exams.length}
                onClick={() => {
                  arrayHelper.push({ examId: null, score: '' })
                }}
              >
                Добавить предмет
              </Button>

              <Spacing spacing='xlarge' />

              <Field
                type='checkbox'
                value={extraExams}
                name='egeExtraExam'
                label={extra}
                as={Checkbox}
              />
            </GridCol>
          </>
        )}
      />
    </Grid>
  )
}

export default SelectEgeDialogEge
